import { publicResourceProvider } from "../../constants/actionTypes";

const cloudVMLoading = (payload) => ({
    type: publicResourceProvider.CLOUD_VM_LOADING,
    payload: payload
})

const getCloudVMListAction = (payload) => ({
    type: publicResourceProvider.GET_CLOUD_VM_LIST_ACTION,
    payload: payload
})
const getCloudVMListSuccess = (payload) => ({
    type: publicResourceProvider.GET_CLOUD_VM_LIST_SUCCESS,
    payload: payload
})
const getCloudVMListError = (payload) => ({
    type: publicResourceProvider.GET_CLOUD_VM_LIST_ERROR,
    payload: payload
})
const getCloudVMListReset = (payload) => ({
    type: publicResourceProvider.GET_CLOUD_VM_LIST_RESET,
    payload: payload
})

const cloudVMOperationAction = (payload) => ({
    type: publicResourceProvider.CLOUD_VM_OPERATION_ACTION,
    payload: payload
})
const cloudVMOperationSuccess = (payload) => ({
    type: publicResourceProvider.CLOUD_VM_OPERATION_SUCCESS,
    payload: payload
})
const cloudVMOperationError = (payload) => ({
    type: publicResourceProvider.CLOUD_VM_OPERATION_ERROR,
    payload: payload
})
const cloudVMOperationReset = (payload) => ({
    type: publicResourceProvider.CLOUD_VM_OPERATION_RESET,
    payload: payload
})

const cloudProviderAzureAction = (payload) => ({
    type: publicResourceProvider.CLOUD_PROVIDER_AZURE_LIST_ACTION,
    payload: payload
})
const cloudProviderAzureSuccess = (payload) => ({
    type: publicResourceProvider.CLOUD_PROVIDER_AZURE_LIST_SUCCESS,
    payload: payload
})
const cloudProviderAzureError = (payload) => ({
    type: publicResourceProvider.CLOUD_PROVIDER_AZURE_LIST_ERROR,
    payload: payload
})
const cloudProviderAzureReset = (payload) => ({
    type: publicResourceProvider.CLOUD_PROVIDER_AZURE_LIST_RESET,
    payload: payload
})

// ── Cascading dropdowns — success/error action creators (dispatched by the saga) ──
const fetchResourceGroupsSuccess = (payload) => ({
    type: publicResourceProvider.FETCH_RESOURCE_GROUPS_SUCCESS,
    payload,
});
const fetchResourceGroupsError = (payload) => ({
    type: publicResourceProvider.FETCH_RESOURCE_GROUPS_ERROR,
    payload,
});
const fetchResourceGroupsReset = () => ({
    type: publicResourceProvider.FETCH_RESOURCE_GROUPS_RESET,
});

const fetchComputeGallerySuccess = (payload) => ({
    type: publicResourceProvider.FETCH_COMPUTE_GALLERY_SUCCESS,
    payload,
});
const fetchComputeGalleryError = (payload) => ({
    type: publicResourceProvider.FETCH_COMPUTE_GALLERY_ERROR,
    payload,
});
const fetchComputeGalleryReset = () => ({
    type: publicResourceProvider.FETCH_COMPUTE_GALLERY_RESET,
});

const fetchGalleryImageSuccess = (payload) => ({
    type: publicResourceProvider.FETCH_GALLERY_IMAGE_SUCCESS,
    payload,
});
const fetchGalleryImageError = (payload) => ({
    type: publicResourceProvider.FETCH_GALLERY_IMAGE_ERROR,
    payload,
});
const fetchGalleryImageReset = () => ({
    type: publicResourceProvider.FETCH_GALLERY_IMAGE_RESET,
});


// ── Instance Size ─────────────────────────────────────────────────────────────
const fetchInstanceSizeSuccess = (payload) => ({
    type: publicResourceProvider.FETCH_INSTANCE_SIZE_SUCCESS,
    payload,
});
const fetchInstanceSizeError = (payload) => ({
    type: publicResourceProvider.FETCH_INSTANCE_SIZE_ERROR,
    payload,
});
const fetchInstanceSizeReset = () => ({
    type: publicResourceProvider.FETCH_INSTANCE_SIZE_RESET,
});

// ── Cascading dropdowns — trigger action creators (dispatched by the component) ──
// payload shape: { url: string, params: string, onSuccess: fn, onError: fn }
// Each creator embeds its own endpoint URL so the component only passes query params.

const fetchResourceGroupsAction = (params) => ({
    type: publicResourceProvider.FETCH_RESOURCE_GROUPS_ACTION,
    payload: {
        url: "/v1/public/azure/image-catalog",
        params,
        onSuccess: fetchResourceGroupsSuccess,
        onError: fetchResourceGroupsError,
    },
});

const fetchComputeGalleryAction = (params) => ({
    type: publicResourceProvider.FETCH_COMPUTE_GALLERY_ACTION,
    payload: {
        url: "/v1/public/azure/image-catalog/galleries",
        params,
        onSuccess: fetchComputeGallerySuccess,
        onError: fetchComputeGalleryError,
    },
});

const fetchGalleryImageAction = (params) => ({
    type: publicResourceProvider.FETCH_GALLERY_IMAGE_ACTION,
    payload: {
        url: "/v1/public/azure/image-catalog/images",
        params,
        onSuccess: fetchGalleryImageSuccess,
        onError: fetchGalleryImageError,
    },
});



const fetchInstanceSizeAction = (params) => ({
    type: publicResourceProvider.FETCH_INSTANCE_SIZE_ACTION,
    payload: params,
});

// ── Azure VM Template Create / Update ─────────────────────────────────────────
const createAzureVmTemplateAction = (payload) => ({
    type: publicResourceProvider.CREATE_AZURE_VM_TEMPLATE_ACTION,
    payload,
});
const createAzureVmTemplateSuccess = (payload) => ({
    type: publicResourceProvider.CREATE_AZURE_VM_TEMPLATE_SUCCESS,
    payload,
});
const createAzureVmTemplateError = (payload) => ({
    type: publicResourceProvider.CREATE_AZURE_VM_TEMPLATE_ERROR,
    payload,
});
const createAzureVmTemplateReset = () => ({
    type: publicResourceProvider.CREATE_AZURE_VM_TEMPLATE_RESET,
});

const updateAzureVmTemplateAction = (id, payload) => ({
    type: publicResourceProvider.UPDATE_AZURE_VM_TEMPLATE_ACTION,
    payload: { id, data: payload },
});
const updateAzureVmTemplateSuccess = (payload) => ({
    type: publicResourceProvider.UPDATE_AZURE_VM_TEMPLATE_SUCCESS,
    payload,
});
const updateAzureVmTemplateError = (payload) => ({
    type: publicResourceProvider.UPDATE_AZURE_VM_TEMPLATE_ERROR,
    payload,
});
const updateAzureVmTemplateReset = () => ({
    type: publicResourceProvider.UPDATE_AZURE_VM_TEMPLATE_RESET,
});

const fetchAzureVmTemplateAction = (id) => ({
    type: publicResourceProvider.FETCH_AZURE_VM_TEMPLATE_ACTION,
    payload: id,
});
const fetchAzureVmTemplateSuccess = (payload) => ({
    type: publicResourceProvider.FETCH_AZURE_VM_TEMPLATE_SUCCESS,
    payload,
});
const fetchAzureVmTemplateError = (payload) => ({
    type: publicResourceProvider.FETCH_AZURE_VM_TEMPLATE_ERROR,
    payload,
});
const fetchAzureVmTemplateReset = () => ({
    type: publicResourceProvider.FETCH_AZURE_VM_TEMPLATE_RESET,
});

const listAzureVmTemplatesAction = (params) => ({
    type: publicResourceProvider.LIST_AZURE_VM_TEMPLATES_ACTION,
    payload: params,
});
const listAzureVmTemplatesSuccess = (payload) => ({
    type: publicResourceProvider.LIST_AZURE_VM_TEMPLATES_SUCCESS,
    payload,
});
const listAzureVmTemplatesError = (payload) => ({
    type: publicResourceProvider.LIST_AZURE_VM_TEMPLATES_ERROR,
    payload,
});
const listAzureVmTemplatesReset = () => ({
    type: publicResourceProvider.LIST_AZURE_VM_TEMPLATES_RESET,
});

const deleteAzureVmTemplateAction = (id) => ({
    type: publicResourceProvider.DELETE_AZURE_VM_TEMPLATE_ACTION,
    payload: id,
});
const deleteAzureVmTemplateSuccess = (payload) => ({
    type: publicResourceProvider.DELETE_AZURE_VM_TEMPLATE_SUCCESS,
    payload,
});
const deleteAzureVmTemplateError = (payload) => ({
    type: publicResourceProvider.DELETE_AZURE_VM_TEMPLATE_ERROR,
    payload,
});
const deleteAzureVmTemplateReset = () => ({
    type: publicResourceProvider.DELETE_AZURE_VM_TEMPLATE_RESET,
});

const publishAzureVmTemplateAction = (payload) => ({
    type: publicResourceProvider.PUBLISH_AZURE_VM_TEMPLATE_ACTION,
    payload: payload,
});
const publishAzureVmTemplateSuccess = (payload) => ({
    type: publicResourceProvider.PUBLISH_AZURE_VM_TEMPLATE_SUCCESS,
    payload,
});
const publishAzureVmTemplateError = (payload) => ({
    type: publicResourceProvider.PUBLISH_AZURE_VM_TEMPLATE_ERROR,
    payload,
});
const publishAzureVmTemplateReset = () => ({
    type: publicResourceProvider.PUBLISH_AZURE_VM_TEMPLATE_RESET,
});

const listAzureSkusAction = (payload) => ({
    type: publicResourceProvider.LIST_AZURE_SKUS_ACTION,
    payload: payload
});
const listAzureSkusSuccess = (payload) => ({
    type: publicResourceProvider.LIST_AZURE_SKUS_SUCCESS,
    payload: payload
});
const listAzureSkusError = (payload) => ({
    type: publicResourceProvider.LIST_AZURE_SKUS_ERROR,
    payload: payload
});
const listAzureSkusReset = () => ({
    type: publicResourceProvider.LIST_AZURE_SKUS_RESET
});

const createAzureSkuAction = (payload) => ({
    type: publicResourceProvider.CREATE_AZURE_SKU_ACTION,
    payload: payload
});
const createAzureSkuSuccess = (payload) => ({
    type: publicResourceProvider.CREATE_AZURE_SKU_SUCCESS,
    payload: payload
});
const createAzureSkuError = (payload) => ({
    type: publicResourceProvider.CREATE_AZURE_SKU_ERROR,
    payload: payload
});
const createAzureSkuReset = () => ({
    type: publicResourceProvider.CREATE_AZURE_SKU_RESET
});

const updateAzureSkuAction = (skuId, data) => ({
    type: publicResourceProvider.UPDATE_AZURE_SKU_ACTION,
    payload: { skuId, data }
});
const updateAzureSkuSuccess = (payload) => ({
    type: publicResourceProvider.UPDATE_AZURE_SKU_SUCCESS,
    payload: payload
});
const updateAzureSkuError = (payload) => ({
    type: publicResourceProvider.UPDATE_AZURE_SKU_ERROR,
    payload: payload
});
const updateAzureSkuReset = () => ({
    type: publicResourceProvider.UPDATE_AZURE_SKU_RESET
});

export {
    cloudVMLoading,
    getCloudVMListAction, getCloudVMListSuccess, getCloudVMListError, getCloudVMListReset,
    cloudVMOperationAction, cloudVMOperationSuccess, cloudVMOperationError, cloudVMOperationReset,
    cloudProviderAzureAction, cloudProviderAzureSuccess, cloudProviderAzureError, cloudProviderAzureReset,
    fetchResourceGroupsAction,
    fetchComputeGalleryAction,
    fetchGalleryImageAction,
    fetchResourceGroupsSuccess, fetchResourceGroupsError, fetchResourceGroupsReset,
    fetchComputeGallerySuccess, fetchComputeGalleryError, fetchComputeGalleryReset,
    fetchGalleryImageSuccess, fetchGalleryImageError, fetchGalleryImageReset,
    fetchInstanceSizeAction,
    fetchInstanceSizeSuccess, fetchInstanceSizeError, fetchInstanceSizeReset,
    createAzureVmTemplateAction, createAzureVmTemplateSuccess, createAzureVmTemplateError, createAzureVmTemplateReset,
    updateAzureVmTemplateAction, updateAzureVmTemplateSuccess, updateAzureVmTemplateError, updateAzureVmTemplateReset,
    fetchAzureVmTemplateAction, fetchAzureVmTemplateSuccess, fetchAzureVmTemplateError, fetchAzureVmTemplateReset,
    listAzureVmTemplatesAction, listAzureVmTemplatesSuccess, listAzureVmTemplatesError, listAzureVmTemplatesReset,
    deleteAzureVmTemplateAction, deleteAzureVmTemplateSuccess, deleteAzureVmTemplateError, deleteAzureVmTemplateReset,
    publishAzureVmTemplateAction, publishAzureVmTemplateSuccess, publishAzureVmTemplateError, publishAzureVmTemplateReset,
    listAzureSkusAction, listAzureSkusSuccess, listAzureSkusError, listAzureSkusReset,
    createAzureSkuAction, createAzureSkuSuccess, createAzureSkuError, createAzureSkuReset,
    updateAzureSkuAction, updateAzureSkuSuccess, updateAzureSkuError, updateAzureSkuReset,
};